import Typography from '@mui/material/Typography';
import { StyleObj } from '../../../../@types';

import { mergeSx } from '../../../../utils/styles';

const styles: StyleObj = {
  root: {
    backgroundColor: 'info.main',
    color: 'neutral.600',
    py: 0.5,
    px: 1,
  },
};

const BonusInfoMessage = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant='body3'
    sx={mergeSx(
      {
        textAlign: 'center',
      },
      styles.root
    )}
  >
    {children}
  </Typography>
);

export default BonusInfoMessage;
